export default {
  apiVersion: 2,
  development: {
    accessToken: '2a6a9daba0786ac56af562afac4d3a8a',
    url: 'http://fabrikkan.dev.moya.is/_/moya/pilot/api',
  },
  staging: {
    accessToken: '2a6a9daba0786ac56af562afac4d3a8a',
    url: 'https://api.fabrikkan.is/_/moya/pilot/api',
  },
  production: {
    accessToken: '2a6a9daba0786ac56af562afac4d3a8a',
    url: 'https://api.fabrikkan.is/_/moya/pilot/api',
  },
};
